import { omniAtom } from "src/utils/atoms";

const prefix = "cdtStudio";

/** Item uniqueIds the studio wants highlighted, merged into the planogram's overlay channels. */
export const cdtStudioHighlightAtom = omniAtom<string[]>({
  prefix,
  key: "highlightedUniqueIds",
  value: [],
});

export const sameHighlightIds = (left: readonly string[], right: readonly string[]): boolean =>
  left.length === right.length && left.every((id, index) => id === right[index]);

/** Three places must agree on this: the page, the create flow, and the step chip. */
export const STUDIO_WIZARD_PARAM = "studio";

/** Side-panel tab. Graph room is the canvas expand, not a second studio posture. */
export const withStudioWizard = (url: string) =>
  `${url}${url.includes("?") ? "&" : "?"}${STUDIO_WIZARD_PARAM}=1`;

export interface CdtStudioPin {
  number: number;
  flagId: string;
}

export const sameStudioPins = (
  left: Readonly<Record<string, CdtStudioPin>>,
  right: Readonly<Record<string, CdtStudioPin>>,
): boolean => {
  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);
  return (
    leftKeys.length === rightKeys.length &&
    leftKeys.every(
      (key) => left[key]?.number === right[key]?.number && left[key]?.flagId === right[key]?.flagId,
    )
  );
};

export const cdtStudioPinsAtom = omniAtom<Readonly<Record<string, CdtStudioPin>>>({
  prefix,
  key: "pins",
  value: {},
});

export const cdtStudioSelectedFlagAtom = omniAtom<string | null>({
  prefix,
  key: "selectedFlagId",
  value: null,
});

export type CdtStudioSelectionSource = "panel" | "pin" | null;

/** Pin hover highlights in place; panel selection may additionally pan to the finding. */
export const cdtStudioSelectionSourceAtom = omniAtom<CdtStudioSelectionSource>({
  prefix,
  key: "selectionSource",
  value: null,
});

/** Precomputed by the studio panel so a pin's popover stays a dumb view. */
export interface CdtStudioExceptionCard {
  number: number;
  kind: string;
  title: string;
  detail: string;
  suggestion: string;
  location: string;
  built: string | null;
  want: string | null;
  canAutoResolve: boolean;
}

export const cdtStudioExceptionCardsAtom = omniAtom<
  Readonly<Record<string, CdtStudioExceptionCard>>
>({
  prefix,
  key: "exceptionCards",
  value: {},
});

export interface CdtStudioActionRequest {
  type: "resolve" | "accept" | "dismiss";
  flagId: string;
}

export const cdtStudioActionRequestAtom = omniAtom<CdtStudioActionRequest | null>({
  prefix,
  key: "actionRequest",
  value: null,
});
